export const selfServiceEndpoints = {
  // Self Services - Item Request
  itemRequest: {
    getAll: (branchId: number, pageNumber: number, pageSize: number, status?: number) =>
      `/api/ItemRequest/GetAll/${branchId}/${pageNumber}/${pageSize}${status ? `?status=${status}` : ''}`,
    getById: (id: number, branchId: number) => `/api/ItemRequest/GetById/${id}/${branchId}`,
    save: '/api/ItemRequest/Save',
    update: '/api/ItemRequest/Update',
    delete: (id: number) => `/api/ItemRequest/Delete/${id}`,
    getAvailableQuantityForEmployeeDepartment: (p: { itemId: number; branchId: number; departmentId: number }) =>
      `/api/ItemRequest/GetAvailableQuantityForEmployeeDepartment/${p.branchId}/${p.itemId}?departmentId=${p.departmentId}`,
  },

  // Self Service - Over Time Request
  overTimeRequest: {
    getAll: (branchId: number, pageNumber: number, pageSize: number, codeType?: number) => {
      const base = `/api/ApiOverTimeRequest/GetAllOverTimeRequests/${branchId}/${pageNumber}/${pageSize}`
      if (codeType === undefined || codeType === null) return base
      return `${base}?codeType=${encodeURIComponent(String(codeType))}`
    },
    getById: (id: number, branchId: number) => `/api/ApiOverTimeRequest/GetOverTimeRequestById/${id}/${branchId}`,
    getStatusLookups: '/api/ApiOverTimeRequest/GetStatusLookups',
    create: '/api/ApiOverTimeRequest/CreateOverTimeRequest',
    update: '/api/ApiOverTimeRequest/UpdateOverTimeRequest',
    delete: (id: number) => `/api/ApiOverTimeRequest/DeleteOverTimeRequest/${id}`,
  },

  // Self Service - Loan Request
  loanRequest: {
    getAll: (pageNumber: number, pageSize: number, branchId: number, codeType: string) =>
      `/api/ApiLoanRequest/GetAllLoanRequests/${pageNumber}/${pageSize}/${branchId}?codeType=${encodeURIComponent(codeType)}`,
    getById: (id: number, branchId: number) => `/api/ApiLoanRequest/GetLoanRequestById/${id}/${branchId}`,
    getLoanTypes: '/api/ApiLoanRequest/GetLoanTypes',
    getStatusLookups: '/api/ApiLoanRequest/GetStatusLookups',
    getActiveEmployees: (branchId: number) => `/api/ApiLoanRequest/GetActiveEmployees/${branchId}`,
    getDepartments: (branchId: number) => `/api/ApiLoanRequest/GetDepartments/${branchId}`,
    getAccounts: (branchId: number) => `/api/ApiLoanRequest/GetAccounts/${branchId}`,
    create: '/api/ApiLoanRequest/CreateLoanRequest',
    update: '/api/ApiLoanRequest/UpdateLoanRequest',
    delete: (id: number) => `/api/ApiLoanRequest/DeleteLoanRequest/${id}`,
  },

  // Self Service - Leave Request
  leaveRequest: {
    getAll: (branchId: number, pageNumber: number, pageSize: number, codeType?: string) => {
      const base = `/api/ApiLeaveRequest/GetAllLeaveRequests/${branchId}/${pageNumber}/${pageSize}`
      return codeType ? `${base}?codeType=${encodeURIComponent(codeType)}` : base
    },
    getById: (id: number, branchId: number) => `/api/ApiLeaveRequest/GetLeaveRequestById/${id}/${branchId}`,
    getLeaveTypes: '/api/ApiLeaveRequest/GetLeaveTypes',
    getStatusLookups: '/api/ApiLeaveRequest/GetStatusLookups',
    getActiveEmployees: (branchId: number) => `/api/ApiLeaveRequest/GetActiveEmployees/${branchId}`,
    getEmployeeContract: (empId: number, branchId: number) => `/api/ApiLeaveRequest/GetEmployeeContract/${empId}/${branchId}`,
    create: '/api/ApiLeaveRequest/CreateLeaveRequest',
    update: '/api/ApiLeaveRequest/UpdateLeaveRequest',
    delete: (id: number) => `/api/ApiLeaveRequest/DeleteLeaveRequest/${id}`,
  },

  // Self Service - Expense Claim Request
  expenseClaim: {
    getAll: (branchId: number, pageNumber: number, pageSize: number) =>
      `/api/ExpenseClaimRequest/GetAllexpenseClaim/${branchId}/${pageNumber}/${pageSize}`,
    getById: (id: number, branchId: number) => `/api/ExpenseClaimRequest/GetAllexpenseClaimbyId/${id}/${branchId}`,
    getLines: (branchId: number) => `/api/ExpenseClaimRequest/GetAllexpenseClaimLines/${branchId}`,
    getLinesById: (id: number, branchId: number) => `/api/ExpenseClaimRequest/GetAllexpenseClaimLinesById/${id}/${branchId}`,
    getDepartments: (branchId: number) => `/api/ExpenseClaimRequest/GetDepartment/${branchId}`,
    getEmployees: (branchId: number) => `/api/ExpenseClaimRequest/GetAllEmployee/${branchId}`,
    getTaxRates: (branchId: number) => `/api/ExpenseClaimRequest/GetTaxrates/${branchId}`,
    getExpenseTypes: '/api/ExpenseClaimRequest/GetExpenseTypes',
    save: '/api/ExpenseClaimRequest/SaveExpenseClaim',
    update: '/api/ExpenseClaimRequest/UpdateExpenseClaim',
    delete: (id: number) => `/api/ExpenseClaimRequest/DeleteExpenseClaim/${id}`,
  },

  // Self Service - Hire Employee Request
  hireEmployeeRequest: {
    create: '/api/HireEmployeeRequest/CreateRequest',
    createEmployeeFromRequest: (id: number) => `/api/HireEmployeeRequest/CreateEmployeeFromRequest/${id}`,
    getStatusLookups: '/api/HireEmployeeRequest/GetStatusLookups',
    delete: (id: number) => `/api/HireEmployeeRequest/DeleteRequest/${id}`,
    getAll: (branchId: number, pageNumber: number, pageSize: number, status?: number | string) => {
      const base = `/api/HireEmployeeRequest/GetAllRequests/${branchId}/${pageNumber}/${pageSize}`
      if (status === undefined || status === null || status === '' || Number(status) === 0) return base
      return `${base}?status=${encodeURIComponent(String(status))}`
    },
    getById: (id: number, branchId: number) => `/api/HireEmployeeRequest/GetRequestById/${id}/${branchId}`,
    getApprovalUsers: (reqId: number) => `/api/HireEmployeeRequest/GetApprovalUsers?reqId=${encodeURIComponent(String(reqId))}`,
  },
} as const

